// Hooks
import useTranslate from "hooks/useTranslate";

// Icons
import Coins from "assets/icons/glory/tournament_bet.svg?react";
import Calendare from "assets/icons/glory/tournament_date.svg?react";
import Cup from "assets/icons/glory/tournament_prize.svg?react";

import "./styles.sass";

interface ITournamentRules {
  minBet: number;
  period: string;
  prizePools: string;
}

const TournamentRules: React.FC<ITournamentRules> = ({
  minBet,
  period,
  prizePools,
}) => {
  const t = useTranslate();

  return (
    <div className="TournamentRules">
      <div className="TournamentRules__title">{t("page.tournament.rules")}</div>
      <div className="TournamentRules__wrapper">
        <div className="TournamentRules__block">
          <div className="TournamentRules__block-icon">
            <Coins className="TournamentRules__icon" />
          </div>
          <div className="TournamentRules__block_content">
            <div className="TournamentRules__block-title">
              {t("page.tournaments.minbet")}
            </div>
            <div className="TournamentRules__block-value">{minBet} EUR</div>
          </div>
        </div>
        <div className="TournamentRules__block">
          <div className="TournamentRules__block-icon">
            <Calendare className="TournamentRules__icon" />
          </div>
          <div className="TournamentRules__block_content">
            <div className="TournamentRules__block-title">
              {t("page.tournaments.period")}
            </div>
            <div className="TournamentRules__block-value">{period}</div>
          </div>
        </div>
        {prizePools && (
          <div className="TournamentRules__block">
            <div className="TournamentRules__block-icon">
              <Cup className="TournamentRules__icon" />
            </div>
            <div className="TournamentRules__block_content">
              <div className="TournamentRules__block-title">
                {t("page.tournament.prize.places")}
              </div>
              <div className="TournamentRules__block-value">{prizePools}</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TournamentRules;
